import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

import "./ProjectMain.css";

import Navbar from "../../components/Navbar/Navbar";
import TopBar from "../../components/TopBar/TopBar";
import Button from "../../components/Button/Button";

import projectweb from "../../Images/projectwebdev.png";
import projectuiux from "../../Images/projectuiux.png";
import projectgraphicsdesign from "../../Images/projectgraphicsdesign.png";

const ProjectMain = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "Projects - Shreeyash Parsawar | Portfolio";
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <section className="sectionProjectMain  ">
          <TopBar />
          <div className="container-fluid text-center">
            <div className="row">
              {/* heading text  */}
              <div className="col-lg-12">
                <div className="wrapper">
                  <svg>
                    <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                      Explore My Creations
                    </text>
                  </svg>
                </div>

                {/* <h1 className="subHeading">Featured Projects</h1> */}
              </div>
              {/* heading text  */}
              {/* ------------------------------------------------------------------------------  */}
              {/* Featured Projects */}
              {/* <div className="container-fluid">
                <Carousel
                  additionalTransfrom={0}
                  arrows={false}
                  autoPlay
                  autoPlaySpeed={2000}
                  centerMode={false}
                  className=""
                  containerclassName="container-with-dots"
                  dotListclassName=""
                  draggable
                  focusOnSelect={false}
                  infinite
                  itemclassName=""
                  keyBoardControl
                  minimumTouchDrag={80}
                  pauseOnHover
                  renderArrowsWhenDisabled={false}
                  renderButtonGroupOutside={false}
                  renderDotsOutside={false}
                  responsive={{
                    desktop: {
                      breakpoint: {
                        max: 3000,
                        min: 1024,
                      },
                      items: 4,
                      partialVisibilityGutter: 40,
                    },
                    mobile: {
                      breakpoint: {
                        max: 464,
                        min: 0,
                      },
                      items: 1,
                      partialVisibilityGutter: 30,
                    },
                    tablet: {
                      breakpoint: {
                        max: 1024,
                        min: 464,
                      },
                      items: 2,
                      partialVisibilityGutter: 30,
                    },
                  }}
                  rewind={false}
                  rewindWithAnimation={false}
                  rtl={false}
                  shouldResetAutoplay
                  showDots={false}
                  sliderclassName=""
                  slidesToSlide={1}
                  swipeable
                >
                  <div className="card m-3 ">
                    <img
                      className="card-img-top"
                      src=".../100px180/"
                      alt="Card image cap"
                    />
                    <div className="card-body">
                      <h5 className="card-title">Card title</h5>
                      <p className="card-text">
                        Some quick example text to build on the card title and
                        make up the bulk of the card's content.
                      </p>
                      <a href="#" className="btn btn-primary">
                        Go somewhere
                      </a>
                    </div>
                  </div>
                </Carousel>
              </div> */}
              {/* Featured Projects */}
              {/* ------------------------------------------------------------------------------  */}
              {/* <div className="container-fluid mt-5">
                <div className="row">
                  <div className="col-lg-12">
                    <h1 className="subHeading">
                      Trilogy of Digital Expressions
                    </h1>
                  </div>
                </div>
              </div> */}
              {/* main project card  */}
              <div className="container mb-5 ">
                <div className="hideontabletresponsive">
                  <div className="row mb-5 ">
                    {/* card 1 */}

                    <div className="col-lg-4 col-md-6 mt-3">
                      <div className="card h-100 projectcard m-3 ">
                        <img className="card-img-top" src={projectweb} alt="" />
                        <div className="card-body ">
                          <h1 className="card-title pb-3 ProjectsubHeading">
                            Website Development
                          </h1>
                        </div>
                        <div className="card-footer pb-5">
                          <Link to="/project/projectwebdev">
                            <Button title="Explore More" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* card 1 */}

                    {/* card 2 */}

                    <div className="col-lg-4 col-md-6 mt-3">
                      <div className="card h-100 projectcard m-3 ">
                        <img
                          className="card-img-top"
                          src={projectuiux}
                          alt=""
                        />
                        <div className="card-body">
                          <h1 className="card-title pb-3 ProjectsubHeading">
                            UI/UX Design
                          </h1>
                        </div>
                        <div className="card-footer pb-5">
                          <Link to="/project/projectuidev">
                            <Button title="Explore More" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* card 2 */}

                    {/* card 3 */}

                    <div className="col-lg-4 col-md-6 mt-3">
                      <div className="card h-100 projectcard m-3 ">
                        <img
                          className="card-img-top"
                          src={projectgraphicsdesign}
                          alt=""
                        />
                        <div className="card-body ">
                          <h1 className="card-title pb-3 ProjectsubHeading">
                            Graphic Design
                          </h1>
                        </div>
                        <div className="card-footer pb-5">
                          <Link to="/project/projectgraphicsdev">
                            <Button title="Explore More" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* card 3 */}
                  </div>
                </div>
              </div>
              {/* --------------------- responsive ------------------- */}
              <div className="container mb-5 ">
                <div className="Tabletresponsivedisplay">
                  <div className="row mb-5 ">
                    {/* card 1 */}

                    <div className="col-lg-4 col-md-6 mt-3">
                      <div className="card h-100 projectcard m-3 ">
                        <img className="card-img-top" src={projectweb} alt="" />
                        <div className="card-body ">
                          <h1 className="card-title pb-3 ProjectsubHeading">
                            Website Development
                          </h1>
                        </div>
                        <div className="card-footer pb-5">
                          <Link to="/project/projectwebdev">
                            <Button title="Explore More" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* card 1 */}

                    {/* card 2 */}

                    <div className="col-lg-4 col-md-6 mt-3">
                      <div className="card h-100 projectcard m-3 ">
                        <img
                          className="card-img-top"
                          src={projectuiux}
                          alt=""
                        />
                        <div className="card-body">
                          <h1 className="card-title pb-3 ProjectsubHeading">
                            UI/UX Design
                          </h1>
                        </div>
                        <div className="card-footer pb-5">
                          <Link to="/project/projectuidev">
                            <Button title="Explore More" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* card 2 */}

                    {/* card 3 */}

                    <div className="col-md-2"></div>

                    <div className="col-lg-4 col-md-8 mt-3">
                      <div className="card h-100 projectcard m-3 ">
                        <img
                          className="card-img-top"
                          src={projectgraphicsdesign}
                          alt=""
                        />
                        <div className="card-body ">
                          <h1 className="card-title pb-3 ProjectsubHeading">
                            Graphic Design
                          </h1>
                        </div>
                        <div className="card-footer pb-5">
                          <Link to="/project/projectgraphicsdev">
                            <Button title="Explore More" />
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2"></div>

                    {/* card 3 */}
                  </div>
                </div>
              </div>
              {/* main project card  */}
            </div>
          </div>

          {/* <Navbar /> */}
        </section>
      )}
    </motion.div>
  );
};

export default ProjectMain;
